import { t } from '@lingui/macro';
import { FieldCheckboxControlled, FieldTextControlled, Flexbox, FormItem, Text } from '@luminovo/design-system';
import { useFormContext } from 'react-hook-form';
import { SourcingTemplateFormValues } from './types';

export function GeneralTab() {
    const { control } = useFormContext<SourcingTemplateFormValues>();

    return (
        <Flexbox
            flexDirection="column"
            style={{ width: '100%', alignSelf: 'center', alignItems: 'center', overflow: 'auto' }}
        >
            <Flexbox flexDirection="column" gap={'28px'} width={'800px'} alignSelf="center">
                <FormItem label={t`Template name`} required>
                    <FieldTextControlled
                        control={control}
                        name="general.name"
                        required
                        FieldProps={{
                            style: { width: '100%' },
                            placeholder: t`Enter template name`,
                        }}
                    />
                </FormItem>
                <FormItem label={t`Description`}>
                    <FieldTextControlled
                        control={control}
                        name="general.description"
                        FieldProps={{
                            style: { width: '100%' },
                            placeholder: t`Enter template description`,
                            multiline: true,
                            rows: 2,
                        }}
                    />
                </FormItem>
                <FormItem label={t`Default template`}>
                    <Flexbox gap={'8px'}>
                        <FieldCheckboxControlled control={control} name="general.isDefaultForSourcing" />
                        <Text>{t`Set as default for RfQ sourcing`}</Text>
                    </Flexbox>
                </FormItem>
            </Flexbox>
        </Flexbox>
    );
}
